import { IconButton } from "@eventbrite/valkyrie-eds-icon-button";
import { CrossChunky } from "@eventbrite/valkyrie-eds-iconography";
import classNames from "classnames";
import React, { FunctionComponent } from "react";
import { BarButton } from "./BarButton";
import { ModalType } from "./constants";

import styles from "./Modal.module.scss";

export interface CloseButtonProps {
  onClose?: () => void;
  hasBackgroundColor?: boolean;
  type?: ModalType;
}

export const CloseButton: FunctionComponent<CloseButtonProps> = ({
  onClose,
  hasBackgroundColor = false,
  type,
}) => {
  if (!onClose) {
    return null;
  }

  const isTakeoverModal = type === ModalType.takeover;
  const takeoverButton = isTakeoverModal ? (
    <div className={styles.takeoverButton}>
      <BarButton onClick={onClose} />
    </div>
  ) : null;
  const buttonClassName = classNames({
    [styles.closeButtonOverImage as string]: hasBackgroundColor,
  });

  return (
    <>
      {takeoverButton}
      <div
        className={classNames(styles.closeButton, {
          [styles.takeoverButton as string]: !!takeoverButton,
        })}
      >
        <IconButton
          data-automation="modal-close-button"
          data-spec="close-button"
          onClick={onClose}
          iconType={<CrossChunky aria-hidden="true" />}
          title={"Close"}
          isOverImage={hasBackgroundColor}
          buttonClassName={buttonClassName}
        />
      </div>
    </>
  );
};
